
const ReturnPage = ({ redirectUrl }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 px-4 sm:px-6">
      <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl p-6 sm:p-8 md:p-10 text-center rounded-2xl shadow-2xl overflow-hidden bg-white/70 backdrop-blur-xl border border-white/40">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-400/20 to-purple-400/20 animate-pulse"></div>

        <div className="relative flex flex-col items-center space-y-6">
          {/* Icon */}
          <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-tr from-indigo-500 to-purple-500 flex items-center justify-center shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12h6m-6 4h6m-7 4h8a2 2 0 002-2V6a2 2 0 00-2-2h-5.586a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 009.586 2H6a2 2 0 00-2 2v16a2 2 0 002 2h2"
              />
            </svg>
          </div>

          {/* Title */}
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 tracking-wide">
            Redirecting to Payment Page...
          </h2>

          {/* Subtitle */}
          <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed">
            Please wait while we securely process your request.
          </p>

          {/* Redirect link */}
          {redirectUrl && (
            <div className="pt-3 text-sm sm:text-base text-gray-600">
              <span>If you are not redirected automatically,&nbsp;</span>
              <a
                href={redirectUrl}
                className="font-semibold text-indigo-600 hover:text-purple-600 underline transition-colors"
              >
                click here
              </a>
              .
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReturnPage;
